import React, { useState, useEffect, Fragment } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import HandleHttpErrors from "../../HandleHttpErrors";
import GetJobType from "../../shared/GetJobType";
const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({ increment, counter, setCounter, jobtypesList }) => {
  const [jobs, setJobs] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const [selectedJobType, setSelectedJobType] = useState(""); // حالة للـ jobtype المحدد
  const axiosPrivate = useAxiosPrivate("application/json");

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "job/", {
          signal: controller.signal,
        });

        const filteredJobs = response.data.filter((job) =>
          selectedJobType ? job.jobtype === parseInt(selectedJobType) : true
        );

        isMounted &&
          setJobs(filteredJobs.sort((a, b) => (a.title > b.title ? 1 : -1)));
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter, selectedJobType]); // تحديث عند تغيير selectedJobType

  const handleEditClick = (event, job) => {
    event.preventDefault();
    setJobId(job.id);
  };

  const handleCancelClick = () => {
    setJobId(null);
  };

  if (!jobs) return null;
  return (
    <>
      <div className="mx-auto">
        <Row>
          <Col sm="10" md={{ size: 3, offset: 1 }}>
            <JobTypeFilter
              jobtypesList={jobtypesList}
              selectedJobType={selectedJobType}
              setSelectedJobType={setSelectedJobType}
            />
            <form onSubmit={increment}>
              <Table hover>
                <thead>
                  <tr>
                    <th> קטגוריה </th>
                    <th> תאור תפקיד</th>
                  </tr>
                </thead>
                <tbody>
                  {jobs?.map((job) => (
                    <Fragment key={job.id}>
                      {jobId === job.id ? (
                        <Edit
                          job={job}
                          handleCancelClick={handleCancelClick}
                          increment={increment}
                          counter={counter}
                          setJobId={setJobId}
                          jobtypesList={jobtypesList}
                        />
                      ) : (
                        <ReadOnlyRows
                          job={job}
                          handleEditClick={handleEditClick}
                          increment={increment}
                          setJobId={setJobId}
                          setShowError={setShowError}
                          setErrorMessage={setErrorMessage}
                          setErrorHeader={setErrorHeader}
                          jobtypesList={jobtypesList}
                        />
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </Table>
            </form>
          </Col>
        </Row>
      </div>

      <ErrorModal
        showError={showError}
        setShowError={setShowError}
        errorMessage={errorMessage}
        errorHeader={errorHeader}
      />
    </>
  );
};
export default Listdelete;

const ReadOnlyRows = ({
  job,
  handleEditClick,
  setJobId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
  jobtypesList,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת מחלקת "${job.title}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const delData = async () => {
      try {
        const response = await axiosPrivate.delete(baseURL + "job/" + job.id, {
          signal: controller.signal,
        });
        if (isMounted) {
          increment();
        }
      } catch (err) {
        if (err.response) {
          alert(
            "לא ניתן למחוק תפקיד שמשויכחם אליו מכרזים או " +
              HandleHttpErrors(err.response.status)
          );
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    delData();
    setJobId(null);
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={job.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>
          {" "}
          <GetJobType jobtypesList={jobtypesList} depIndex={job.jobtype} />
        </td>
        <td>{job.title}</td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, job)}
          >
            <FiEdit2 />
          </button>
          <span> </span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => showDeleteModal("job", job.id, event)}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};

const JobTypeFilter = ({
  jobtypesList,
  selectedJobType,
  setSelectedJobType,
}) => {
  return (
    <select
      value={selectedJobType}
      onChange={(e) => setSelectedJobType(e.target.value)}
    >
      <option value="">כל הקטגוריות</option>
      {jobtypesList.map((jobtype) => (
        <option key={jobtype.id} value={jobtype.id}>
          {jobtype.title}
        </option>
      ))}
    </select>
  );
};
